// extracted by mini-css-extract-plugin
export default {"container":"YV-z","title":"ZV-z","link":"_V-z"};